import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A promise that resolves to an instance of `}<inlineCode parentName="p">{`INativePaymentMethodManager`}</inlineCode>{` or `}<inlineCode parentName="p">{`null`}</inlineCode>{`.
An interface for creating a native payment method button.`}</p>
    <Group summary='INativePaymentMethodManager' mdxType="Group">
      <Item title='createButton' subtitle='() => IHeadlessPaymentMethodButton' mdxType="Item">
        <p>{`Create a native payment method button. Returns a
`}<a parentName="p" {...{
            "href": "/docs/sdk/web/2.x.x/primer-headless-checkout/headlessPaymentMethodButton"
          }}>{`HeadlessPaymentMethodButton`}</a>{`.`}</p>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      